import React from "react";
import LegalLayout, { LEGAL_ENTITY } from "../../components/LegalLayout";

export default function CookiesPage() {
  const sections = [
    {
      heading: "Ce sunt cookie-urile",
      body: [
        "Cookie-urile sunt fișiere mici de text pe care un site web le stochează pe dispozitivul dumneavoastră (computer, telefon, tabletă) atunci când îl vizitați.",
        "Ele ne ajută să facem Site-ul VIS DE ZI să funcționeze corect, să ne amintim preferințele dumneavoastră (ex. produsele adăugate în coș) și să înțelegem cum este folosit Site-ul.",
      ],
    },
    {
      heading: "Ce cookie-uri folosim",
      body: [
        "Cookie-uri strict necesare — sunt esențiale pentru funcționarea Site-ului. De exemplu, memorarea coșului de cumpărături (vdz_cart) și a sesiunii de administrare (access_token). Fără aceste cookie-uri, Site-ul nu poate funcționa corect.",
        "Cookie-uri de preferințe — rețin alegerile dumneavoastră, cum ar fi afișarea filtrelor din magazin.",
        "Momentan nu folosim cookie-uri de marketing, analytics terți sau remarketing. Dacă vom introduce în viitor Google Analytics sau Meta Pixel, vom actualiza această pagină și vom solicita acordul dumneavoastră explicit.",
      ],
    },
    {
      heading: "Durata cookie-urilor",
      body: [
        "Cookie-urile strict necesare rămân pe dispozitiv doar pe durata sesiunii dumneavoastră sau până când le ștergeți manual.",
        "Cookie-ul coșului de cumpărături este stocat local în browser (localStorage) până îl goliți sau ștergeți datele browser-ului.",
      ],
    },
    {
      heading: "Cum puteți controla cookie-urile",
      body: [
        "Puteți accepta sau refuza cookie-urile din setările browser-ului dumneavoastră. Majoritatea browserelor acceptă cookie-uri automat, dar le puteți dezactiva.",
        "Pentru detalii specifice despre cum să gestionați cookie-urile, consultați instrucțiunile browser-ului dumneavoastră:",
        "• Chrome: https://support.google.com/chrome/answer/95647",
        "• Firefox: https://support.mozilla.org/ro/kb/activarea-si-dezactivarea-cookie-urilor",
        "• Safari: https://support.apple.com/ro-ro/guide/safari/sfri11471/mac",
        "• Edge: https://support.microsoft.com/ro-ro/microsoft-edge",
        "Dezactivarea cookie-urilor strict necesare poate face ca anumite funcționalități ale Site-ului (ex. coșul de cumpărături) să nu mai funcționeze corect.",
      ],
    },
    {
      heading: "Cookie-uri terțe",
      body: [
        "Momentan nu folosim niciun serviciu terț care să plaseze cookie-uri pe dispozitivul dumneavoastră.",
        "Rețelele sociale la care facem referire în footer (Instagram, TikTok, Facebook) își au propriile politici de cookie-uri — vă rugăm să le consultați direct pe platformele respective.",
      ],
    },
    {
      heading: "Modificări",
      body: [
        "Această Politică de cookies poate fi actualizată. Vom afișa data ultimei actualizări în partea de sus a paginii.",
      ],
    },
    {
      heading: "Contact",
      body: [
        "Pentru orice întrebări legate de utilizarea cookie-urilor, ne puteți scrie la office@visdezi.ro.",
      ],
    },
  ];

  return (
    <LegalLayout
      eyebrow="Document legal"
      title="Politica de cookies"
      lastUpdated="1 octombrie 2026"
      sections={sections}
      legalEntity={LEGAL_ENTITY}
    />
  );
}
